import React from "react";
import { ToggleInput } from "@strapi/design-system/ToggleInput";

export const Toggle = ({
  styles,
  label,
  name,
  onLabel,
  offLabel,
  required,
  value = false,
  onToggleChange,
  disabled = false,
}) => {
  return (
    <div className={`${styles}`}>
      <ToggleInput
        label={label}
        name={name}
        onLabel={onLabel}
        offLabel={offLabel}
        required={required}
        checked={value}
        disabled={disabled}
        onChange={disabled ? () => {} : onToggleChange}
      />
    </div>
  );
};
